import { useGetControllerLogs } from '@/modules/CombinedLogs'
import { calculateMileageLoss } from '../helpers/calculateMileageLoss'
import { useMemo } from 'react'
import { useGetSharedLogs } from '@/modules/CombinedLogs/api/useGetControllerLogs'
import { useLocation } from 'react-router-dom'
import { ROUTES } from '@/router'

export const useCalculateMileageLoss = () => {
    const { data: controllerLogs = [] } = useGetControllerLogs()
    const { data: sharedLogs = [] } = useGetSharedLogs()
    const { pathname } = useLocation()

    const isSharedLogPage = pathname.includes(ROUTES.SHARED_LOG)

    const logs = useMemo(() => {
        if (isSharedLogPage) {
            return sharedLogs
        }
        return controllerLogs || []
    }, [controllerLogs, sharedLogs, isSharedLogPage])

    return useMemo(() => calculateMileageLoss(logs), [logs])
}
